import { gsap, ScrollToPlugin } from 'gsap/all'
import DeviceCheck from '../utils/deviceCheck'

// SmoothScrollAnchor
export default class SmoothScrollAnchor {
  constructor(tgt) {
    this.deviceCheck = new DeviceCheck()
    this.triggers = document.querySelectorAll('.js-scroll')
    this.triggersArr = Array.prototype.slice.call(this.triggers, 0)
    this.init()
  }
  init() {
    gsap.registerPlugin(ScrollToPlugin)
    this.bindEvent()
  }
  bindEvent() {
    this.triggersArr.forEach((el) => {
      el.addEventListener(
        'click',
        (e) => {
          e.preventDefault()
          const tgt = e.currentTarget
          const url = tgt.getAttribute('href')
          const parts = url.split('#')
          let margin = 0
          if (this.deviceCheck.getDeviceSize() == 'mobile') {
            if (tgt.dataset.marginSp != null) {
              margin = Number(tgt.dataset.marginSp)
            }
          } else {
            if (tgt.dataset.marginPc != null) {
              margin = Number(tgt.dataset.marginPc)
            }
          }
          this.scrollTarget(parts[1], margin)
        },
        false,
      )
    })
  }
  scrollTarget(id, mg) {
    const target = document.getElementById(id)
    const rect = target.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const targetTop = rect.top + scrollTop
    let offsetH = 0
    let pc = 80
    let sp = 40
    let margin = 0

    if (mg !== undefined) {
      margin = mg
    }

    if (this.deviceCheck.getDeviceSize() == 'mobile') {
      offsetH = sp + margin
    } else {
      offsetH = pc + margin
    }

    let target_top = targetTop - offsetH

    this.scrollTo(target_top)
  }
  scrollTo(t) {
    gsap.to(window, { duration: 0.8, scrollTo: { y: t, autoKill: false }, ease: 'power2.inOut' })
  }
}
